import React from 'react';
import PropTypes from 'prop-types';
import Pressable from "react-native-web/dist/exports/Pressable";
import Image from "react-native-web/dist/exports/Image";
import { useCarousel } from './CarouselContext';
import { useThemeTokensCallback } from '../ThemeProvider';
import { useViewport } from '../ViewportProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const selectPressableTokens = _ref => {
  let {
    borderColor,
    borderRadius,
    borderWidth,
    margin,
    padding
  } = _ref;
  return {
    borderColor,
    borderRadius,
    borderWidth,
    margin,
    padding
  };
};

/**
 * `Carousel.Thumbnail` is used to wrap the content of an individual slide and is suppsoed to be the
 * only top-level component passed to the `Carousel`
 */
const CarouselThumbnail = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    accessibilityLabel,
    alt,
    index,
    src
  } = _ref2;
  const {
    activeIndex,
    itemLabel,
    totalItems,
    getCopyWithPlaceholders,
    goTo
  } = useCarousel();
  const getThumbnailTokens = useThemeTokensCallback('CarouselThumbnail');
  const viewport = useViewport();
  const thumbnailTitle = alt ?? getCopyWithPlaceholders('stepTrackerLabel').replace(/%\{itemLabel\}/g, itemLabel).replace(/%\{stepNumber\}/g, index).replace(/%\{stepCount\}/g, totalItems);
  const handlePress = () => goTo(index);
  const handleKeyDown = event => {
    // Allow using the spacebar for navigation
    if (event?.key === ' ') goTo(index);
  };
  const {
    borderWidth,
    padding,
    selectedBorderColor,
    selectedBorderWidth,
    size,
    margin
  } = getThumbnailTokens({
    viewport
  });
  const styles = {
    image: {
      height: size,
      width: size
    },
    selected: {
      borderColor: selectedBorderColor,
      borderWidth: selectedBorderWidth,
      padding: padding - selectedBorderWidth,
      marginBottom: margin + selectedBorderWidth
    },
    nonSelected: {
      padding: padding - borderWidth,
      marginBottom: margin + selectedBorderWidth
    }
  };
  return /*#__PURE__*/_jsx(Pressable, {
    onKeyDown: handleKeyDown,
    onPress: handlePress,
    style: _ref3 => {
      let {
        hovered,
        pressed,
        focused
      } = _ref3;
      const pressableStyles = selectPressableTokens(getThumbnailTokens({
        hover: hovered,
        pressed,
        focus: focused
      }));
      return [pressableStyles, index === activeIndex ? [styles.selected, {
        outline: 'none'
      }] : styles.nonSelected];
    },
    ref: ref,
    children: /*#__PURE__*/_jsx(Image, {
      accessibilityIgnoresInvertColors: true,
      accessibilityLabel: accessibilityLabel ?? alt,
      source: src,
      style: styles.image,
      title: thumbnailTitle
    })
  }, src);
});
CarouselThumbnail.displayName = 'CarouselThumbnail';
CarouselThumbnail.propTypes = {
  accessibilityLabel: PropTypes.string,
  alt: PropTypes.string,
  index: PropTypes.number,
  src: PropTypes.string
};
export default CarouselThumbnail;